<template>
  <div class="container no-padding-container text-gray-600">
    <div class="px-5">
      <div class="pt-5 md:pt-12">
        <h1 class="ota-title mb-3 text-center md:mb-10" v-text="$t('Sustainability.Content.Title')" />
        <p class="ota-body-light" v-html="$t('Sustainability.Content.Description')" />
      </div>
      <div class="lg:flex pt-12">
        <p class="ota-subtitle pb-12 pr-10 lg:pt-4" v-html="$t('Sustainability.General.Subjects')" />
        <div class="mb-10 flex-1 flex justify-end">
          <div class="right-flex w-full">
            <ProductAccordion
              v-for="(contentBlock, index) in content"
              :key="`${contentBlock.Question}-${index}`"
              class="mt-5 border-b"
            >
              <template v-slot:trigger>
                {{ contentBlock.Question }}
              </template>
              <template v-slot:content>
                <div class="ota-small-light pb-5 md:pb-10" v-html="contentBlock.Answer" />
              </template>
            </ProductAccordion>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductAccordion from '@/components/Webshop/ProductAccordion'

export default {
  name: 'Sustainability',
  layout: 'homepage',
  components: { ProductAccordion },
  computed: {
    content () {
      return this.$t('Sustainability.Content.Questions')
    }
  },
  head () {
    return {
      title: this.$t('Sustainability.PageTitle'),
      meta: [
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: this.$t('Sustainability.Description')
        }
      ]
    }
  }
}
</script>

<style lang="postcss" scoped>
.product-accordion {
  >>> b {
    @apply font-extrabold;
  }

  >>> .ota-p18 {
    font-size: 1.5rem;
  }
}

.right-flex {
  max-width: 75rem;
}
</style>
